<template>
<div>
  <v-toolbar color="white">
    <!-- <v-toolbar-title class="white--text">Conference</v-toolbar-title> -->
    <v-toolbar-items>
      <v-layout align-center fill-height>
      <img src="/static/img/inet/inetlogo.jpg" alt="" style="height:50px; padding-top:4px;">
      </v-layout>
    </v-toolbar-items>
    <v-spacer></v-spacer>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" style="color:grey;"></v-toolbar-side-icon>

  </v-toolbar>
  <div class="bodyConference hidden-sm-and-down" style="height:100vh;">
    <!-- <v-layout justify-center> -->
    <div class="bodytab" >
      <v-tabs
        v-model="tab"
        width="800"
        color="white"
        slider-color="#1976D2"
      >
          <v-tab href="#tab-1" style="color:#1976D2;">
            สร้างห้องประชุม
          </v-tab>

          <!-- <v-tab href="#tab-2"  style="color:#1976D2;">
            การประชุมที่จะมาถึง
          </v-tab>

          <v-tab href="#tab-3"  style="color:#1976D2;">
            ประวัติการประชุม
          </v-tab> -->

        <v-tabs-items v-model="tab" >
          <v-tab-item id="tab-1">
      <v-card>
        <v-layout column justify-center style="padding-left:120px; padding-right:120px;">
          <div style="padding:24px 24px 0px 24px;" >
            <!-- style="max-height:450px;  overflow-y:auto;" -->
            <!-- "$vuetify.breakpoint.xs ? 450 : '250'" -->
              <v-layout column :class="$vuetify.breakpoint.height <400 ? 'web' : 'other_web'">
                <!-- <v-flex xs12 sm12 md12 style="margin-bottom:8px;">
                  <v-layout row>
                    <v-flex xs3 sm3 md3>
                      <v-layout align-center fill-height style="height:43px;">
                      <span class="headerInput">หัวข้อการประชุม :</span>
                      </v-layout>
                    </v-flex>
                    <v-flex xs7 sm7 md7>
                      <v-text-field
                        solo
                        hide-details
                        v-model="subject"
                        class="CSChatThai"
                        label="หัวข้อการประชุม"
                        style="text-align:center;"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 style="">
                  <v-layout row>
                    <v-flex xs3 sm3 md3>
                      <v-layout align-center fill-height>
                        <span class="headerInput">วันและเวลา :</span>
                      </v-layout>
                    </v-flex>
                    <v-flex xs7 sm7 md7>
                      <v-layout column>
                        <v-flex xs12 sm12 md12 >
                          <date-picker
                            v-model="date"
                            value-type="date"
                            placeholder="กรุณาเลือกวัน"
                            :disabled-date="notBeforeToday"
                            format="dddd, MMM, YYYY"
                          ></date-picker>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-layout row>
                    <v-flex xs3 sm3 md3>
                    </v-flex>
                    <v-flex xs7 sm7 md7>
                      <v-flex xs12 sm12 md12>
                        <v-layout row>
                          <v-flex xs5 sm5 md5 >
                            <date-picker
                              v-model="time"
                              type="time"
                              placeholder="กรุณาเลือกเวลา"
                              format="HH:mm"
                            ></date-picker>
                          </v-flex>
                          <v-flex xs5 sm5 md5 style="padding-left:12px;">
                            <input type="text" placeholder="ระยะเวลา" class="mx-input" v-model="duration" >
                          </v-flex>
                          <v-flex>
                            <v-layout align-center justify-center fill-height>
                              <span class="Inputminute">นาที</span>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 style="margin-bottom:15px;">
                  <v-layout row>
                    <v-flex xs3 sm3 md3>
                      <v-layout align-center fill-height style="height:55px;">
                        <span class="headerInput">ส่งคำเชิญไปที่ :</span>
                      </v-layout>
                    </v-flex>
                    <v-flex xs7 sm7 md7>
                      <v-flex xs12 sm12 md12>
                        <v-layout row>
                          <v-flex xs12 sm12 md12>
                            <v-combobox
                              multiple
                              v-model="member"
                              append-icon
                              chips
                              small-chips
                              placeholder="กรุณากรอกอีเมล"
                              allow-overflow
                              deletable-chips
                              outline
                              class="tag-input"
                              :search-input.sync="search"
                              hide-details
                              >
                            </v-combobox>
                            <p v-if="checktypemail === false" style="color:red; margin-bottom:0px;">รูปแบบอีเมลไม่ถูกต้อง</p>
                          </v-flex>
                          <v-flex xs3 sm3 md3>
                            <v-btn  @click="updateTags" outline small>
                              <v-icon>mdi-plus</v-icon>
                              เพิ่ม
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12 style="">
                  <v-layout row>
                    <v-flex xs3 sm3 md3>
                      <v-layout align-center fill-height style="height:43px;">
                        <span class="headerInput" >ตั้งรหัสผ่าน :</span>
                      </v-layout>
                    </v-flex>
                    <v-flex xs7 sm7 md7>
                      <v-text-field
                        solo
                        label="รหัสผ่าน"
                        v-model="password"
                        class="CSChatThai"
                        style="text-align:center;"
                        hide-details
                        append-icon="fas fa-dice"
                        @click:append="makeid()"
                      ></v-text-field>
                      <v-icon>mdi-dice</v-icon>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-layout row>
                    <v-flex xs3 sm3 md3>
                      <v-layout align-center fill-height>
                        <span class="headerInput">Secret meeting :</span>
                      </v-layout>
                    </v-flex>
                    <v-flex xs7 sm7 md7>
                      <v-switch v-model="switch1"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                      <div style="padding:24px; width:70vh;" >
                        <v-layout column>
                          <span class="headerInputMobile" style="margin-bottom:10px;">หัวข้อการประชุม :</span>
                          <v-text-field
                            solo
                            label="หัวข้อการประชุม"
                            v-model="subject"
                            class="CSChatThai"
                            style="text-align:center;"
                            hide-details
                          ></v-text-field>
                          <v-flex xs12 sm12 md12 style="margin-bottom:8px;">
                            <div style="margin-bottom:10px; margin-top:10px;">
                              <span class="headerInputMobile" >วันและเวลา :</span>
                            </div>
                            <date-picker
                              style="margin-top:10px;"
                              v-model="date"
                              value-type="date"
                              placeholder="กรุณาเลือกวัน"
                              :disabled-date="notBeforeToday"
                              format="dddd, MMM, YYYY"
                            ></date-picker>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row>
                              <v-flex xs12 sm12 md12>
                                <v-layout row>
                                  <v-flex xs5 sm5 md5 >
                                    <date-picker
                                      v-model="time"
                                      type="time"
                                      placeholder="กรุณาเลือกเวลา"
                                      format="HH:mm"
                                    ></date-picker>
                                  </v-flex>

                                  <v-flex xs5 sm5 md5 style="padding-left:12px;">
                                      <input type="text" placeholder="ระยะเวลา" class="mx-input" v-model="duration" >
                                    </v-flex>
                                    <v-flex>
                                      <v-layout align-center justify-center fill-height>
                                        <span class="Inputminute">นาที</span>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              <!-- </v-flex> -->
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12 style="margin-bottom:15px; margin-top:15px;">
                           <!-- <v-layout row> -->
                              <v-flex xs12 sm12 md12 style="margin-top:10px; margin-bottom:10px;">
                                <span class="headerInputMobile" >ส่งคำเชิญไปที่ :</span>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <!-- <v-flex xs12 sm12 md12> -->
                                  <v-layout row>
                                    <v-flex xs9 sm9 md9>
                                      <v-combobox
                                        multiple
                                        placeholder="กรุณากรอกอีเมล"
                                        v-model="member"
                                        outline
                                        append-icon
                                        chips
                                        small-chips
                                        allow-overflow
                                        deletable-chips
                                        class="tag-input"
                                        :search-input.sync="search"
                                        hide-details
                                        >
                                      </v-combobox>
                                      <p v-if="checktypemail === false" style="color:red; margin-bottom:0px;">รูปแบบอีเมลไม่ถูกต้อง</p>
                                    </v-flex>
                                    <v-flex xs3 sm3 md3>
                                      <v-btn  @click="updateTags" outline small>
                                        <v-icon>mdi-plus</v-icon>
                                        เพิ่ม
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                              </v-flex>
                          </v-flex>
                          <v-flex xs12 sm12 md12 style="margin-bottom:10px;">
                            <div style="margin-bottom:10px;">
                              <span class="headerInputMobile" >ตั้งรหัสผ่าน :</span>
                            </div>
                            <v-text-field
                              solo
                              label="รหัสผ่าน"
                              v-model="password"
                              class="CSChatThai"
                              hide-details
                              style="text-align:center;"
                              append-icon="fas fa-dice"
                              @click:append="makeid()"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12 style="padding-top:10px; padding-bottom:10px;">
                            <v-layout row>
                              <v-flex xs6 sm6 md6>
                                <v-layout align-center fill-height >
                                  <span class="headerInputMobile">Secret meeting :</span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs6 sm6 md6 >
                                <v-switch v-model="switch1" hide-details ></v-switch>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout row justify-end style="padding-bottom:10px;">
                          <v-btn color="primary" :disabled="disableBtn()" @click="createRoomConference()" style="border-radius:12px;">บันทึก</v-btn>
                          <v-btn outline @click="cancle()" style="border-radius:12px; color:grey;">เคลียร์</v-btn>
                        </v-layout>
                    </div>
              </v-layout>
          </div>
              <!-- <v-layout row justify-end style="padding-right:34px; padding-bottom:24px;">
                <v-btn color="primary" :disabled="disableBtn()" @click="createRoomConference()" style="border-radius:12px;">บันทึก</v-btn>
                <v-btn outline @click="cancle()" style="border-radius:12px; color:grey;">เคลียร์</v-btn>
              </v-layout> -->
        </v-layout>
      </v-card>
            <!-- <v-btn @click="openDialog">สร้างห้องประชุม</v-btn> -->
          </v-tab-item>
          <v-tab-item id="tab-2">
            <v-card>
            <!-- การประชุมที่จะมาถึง -->
            <!-- <v-flex xs11 sm11 md11> -->
              <v-layout justify-center >
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  class="elevation-1"
                  style="margin-top:20px; margin-bottom:20px;"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs-right">{{ props.item.calories }}</td>
                    <td class="text-xs-right">{{ props.item.fat }}</td>
                    <td class="text-xs-right">{{ props.item.carbs }}</td>
                    <td class="text-xs-right">{{ props.item.protein }}</td>
                    <td class="text-xs-right">{{ props.item.iron }}</td>
                  </template>
                </v-data-table>
              </v-layout>
            <!-- </v-flex> -->
            </v-card>
          </v-tab-item>
          <v-tab-item id="tab-3">
            <v-card>
            <v-layout justify-center >
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  class="elevation-1"
                  style="margin-top:20px; margin-bottom:20px;"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs-right">{{ props.item.calories }}</td>
                    <td class="text-xs-right">{{ props.item.fat }}</td>
                    <td class="text-xs-right">{{ props.item.carbs }}</td>
                    <td class="text-xs-right">{{ props.item.protein }}</td>
                    <td class="text-xs-right">{{ props.item.iron }}</td>
                  </template>
                </v-data-table>
              </v-layout>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>

    <!-- </v-layout> -->
  </div>

<!-- mobile -->
    <div class="hidden-md-and-up" style="height:100vh">
      <v-layout justify-center style="margin-top:24px !important;">
        <v-flex xs11 sm11 md11>
          <v-tabs
            v-model="tab"
            color="white"
            slider-color="#1976D2"
          >
              <v-tab href="#tab-1"  style="color:#1976D2;">
                สร้างห้องประชุม
              </v-tab>

              <!-- <v-tab href="#tab-2"  style="color:#1976D2;">
                การประชุมที่จะมาถึง
              </v-tab>

              <v-tab href="#tab-3"  style="color:#1976D2;">
                ประวัติการประชุม
              </v-tab> -->

            <v-tabs-items v-model="tab" >
              <v-tab-item id="tab-1">
                <v-card>
                  <!-- :class="$vuetify.breakpoint.height <400 ? 'mobilelayoutX' : 'mobilelayout'"  -->
                  <!-- class="mobilelayout" -->
                  <!-- <div class="container">
  <iframe class="responsive-iframe" src="https://www.youtube.com/embed/tgbNymZ7vqY"></iframe>
</div> -->
                  <!-- <div v-bind:style="{ color: activeColor, fontSize: fontSize + 'px', height: 'calc( 100vh - ' + height + 'px);'}">xfzfsdxcxcvx</div> -->
                    <!-- {{height}} -->
                    <!-- :style="{height:totalHeight+'px'}" -->
                    <!-- style="height: 500px; overflow-y:auto; overflow-x:hidden;" -->
                    <!-- {{height}} -->
                   <v-layout justify-center :style="{height:'calc(100vh - '+128+'px'}" style="overflow-y:auto;">
                    <div style="padding:24px; width:70vh;" >
                        <v-layout column>
                          <span class="headerInputMobile" style="margin-bottom:10px;">หัวข้อการประชุม :</span>
                          <v-text-field
                            solo
                            label="หัวข้อการประชุม"
                            v-model="subject"
                            class="CSChatThai"
                            style="text-align:center;"
                            hide-details
                          ></v-text-field>
                          <v-flex xs12 sm12 md12 style="margin-bottom:8px;">
                            <div style="margin-bottom:10px; margin-top:10px;">
                              <span class="headerInputMobile" >วันและเวลา :</span>
                            </div>
                            <date-picker
                              style="margin-top:10px;"
                              v-model="date"
                              value-type="date"
                              placeholder="กรุณาเลือกวัน"
                              :disabled-date="notBeforeToday"
                              format="dddd, MMM, YYYY"
                            ></date-picker>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row>
                              <v-flex xs12 sm12 md12>
                                <v-layout row>
                                  <v-flex xs5 sm5 md5 >
                                    <date-picker
                                      v-model="time"
                                      type="time"
                                      placeholder="กรุณาเลือกเวลา"
                                      format="HH:mm"
                                    ></date-picker>
                                  </v-flex>

                                  <v-flex xs5 sm5 md5 style="padding-left:12px;">
                                      <input type="text" placeholder="ระยะเวลา" class="mx-input" v-model="duration" >
                                    </v-flex>
                                    <v-flex>
                                      <v-layout align-center justify-center fill-height>
                                        <span class="Inputminute">นาที</span>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              <!-- </v-flex> -->
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12 style="margin-bottom:15px; margin-top:15px;">
                           <!-- <v-layout row> -->
                              <v-flex xs12 sm12 md12 style="margin-top:10px; margin-bottom:10px;">
                                <span class="headerInputMobile" >ส่งคำเชิญไปที่ :</span>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <!-- <v-flex xs12 sm12 md12> -->
                                  <v-layout row>
                                    <v-flex xs9 sm9 md9>
                                      <v-combobox
                                        multiple
                                        placeholder="กรุณากรอกอีเมล"
                                        v-model="member"
                                        outline
                                        append-icon
                                        chips
                                        small-chips
                                        allow-overflow
                                        deletable-chips
                                        class="tag-input"
                                        :search-input.sync="search"
                                        hide-details
                                        >
                                      </v-combobox>
                                      <p v-if="checktypemail === false" style="color:red; margin-bottom:0px;">รูปแบบอีเมลไม่ถูกต้อง</p>
                                    </v-flex>
                                    <v-flex xs3 sm3 md3>
                                      <v-btn  @click="updateTags" outline small>
                                        <v-icon>mdi-plus</v-icon>
                                        เพิ่ม
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                              </v-flex>
                          </v-flex>
                          <v-flex xs12 sm12 md12 style="margin-bottom:10px;">
                            <div style="margin-bottom:10px;">
                              <span class="headerInputMobile" >ตั้งรหัสผ่าน :</span>
                            </div>
                            <v-text-field
                              solo
                              label="รหัสผ่าน"
                              v-model="password"
                              class="CSChatThai"
                              hide-details
                              style="text-align:center;"
                              append-icon="fas fa-dice"
                              @click:append="makeid()"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12 style="padding-top:10px; padding-bottom:10px;">
                            <v-layout row>
                              <v-flex xs6 sm6 md6>
                                <v-layout align-center fill-height >
                                  <span class="headerInputMobile">Secret meeting :</span>
                                </v-layout>
                              </v-flex>
                              <v-flex xs6 sm6 md6 >
                                <v-switch v-model="switch1" hide-details ></v-switch>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout row justify-end style="padding-bottom:10px;">
                          <v-btn color="primary" :disabled="disableBtn()" @click="createRoomConference()" style="border-radius:12px;">บันทึก</v-btn>
                          <v-btn outline @click="cancle()" style="border-radius:12px; color:grey;">เคลียร์</v-btn>
                        </v-layout>
                    </div>
                  </v-layout>
                </v-card>
              </v-tab-item>
              <v-tab-item id="tab-2">
                <v-card>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-right">{{ props.item.calories }}</td>
                      <td class="text-xs-right">{{ props.item.fat }}</td>
                      <td class="text-xs-right">{{ props.item.carbs }}</td>
                      <td class="text-xs-right">{{ props.item.protein }}</td>
                      <td class="text-xs-right">{{ props.item.iron }}</td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>

              <v-tab-item id="tab-3">
                <v-card>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-right">{{ props.item.calories }}</td>
                      <td class="text-xs-right">{{ props.item.fat }}</td>
                      <td class="text-xs-right">{{ props.item.carbs }}</td>
                      <td class="text-xs-right">{{ props.item.protein }}</td>
                      <td class="text-xs-right">{{ props.item.iron }}</td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-flex>
      </v-layout>
    </div>
   <v-navigation-drawer
      v-if="drawer"
      v-model="drawer"
      absolute
      temporary
      right
      height="100vh"
      width="200"
    >
      <v-list>
        <v-list-tile>
          <v-list-tile-avatar>
            <img src="https://cdn.vuetifyjs.com/images/lists/1.jpg">
          </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title >test1234567 test</v-list-tile-title>
                <v-list-tile-sub-title>teset@mail.com</v-list-tile-sub-title>
              </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
</div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  components: {
    DatePicker
  },
  data () {
    return  {
      showPassword: false,
      show1: false,
      messages: [
        {
          avatar: 'https://avatars0.githubusercontent.com/u/9064066?v=4&s=460',
          name: 'John Leider',
          title: 'Welcome to Vuetify.js!',
          excerpt: 'Thank you for joining our community...'
        },
        {
          color: 'red',
          icon: 'people',
          name: 'Social',
          new: 1,
          total: 3,
          title: 'Twitter'
        },
        {
          color: 'teal',
          icon: 'local_offer',
          name: 'Promos',
          new: 2,
          total: 4,
          title: 'Shop your way',
          exceprt: 'New deals available, Join Today'
        }
      ],
      createroom_dialog: false,
      text: 'test',
      tab: 'tab-1',
      headers: [
        {
          text: 'Dessert (100g serving)',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Calories', value: 'calories' },
        { text: 'Fat (g)', value: 'fat' },
        { text: 'Carbs (g)', value: 'carbs' },
        { text: 'Protein (g)', value: 'protein' },
        { text: 'Iron (%)', value: 'iron' }
      ],
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: '1%'
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: '1%'
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: '7%'
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: '8%'
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: '16%'
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: '0%'
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: '2%'
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: '45%'
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: '22%'
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: '6%'
        }
      ],
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],
      drawer: null,
      member: [],
      items: [],
      search: "", //sync search
      //-----------------------------
      switch1: true,
      date: new Date(),
      time: new Date(),
      subject:'',
      duration: '',
      password: '',
      phones:[],
      checktypemail: null,
      member_invite : [],
      emailRules: [
        function(v){
        for (var i = 0; i < v.length; i++) {
          if (!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v[i]))) {
            // this.checktypemail = false
            return 'รูปแบบอีเมลไม่ถูกต้อง';
          }
          // v[i] = parseInt(v[i]);
        }
      }],
        activeColor: 'red',
        fontSize: 30,
        height: window.innerHeight,
        totalHeight: 100
      // emailRules: [
      //   v => {
      //     if (!v || v.length < 1)
      //       return 'Input is required';
      //         // else if (v.length > 0) {
      //         //   for (let i = 0; i < v.length; i++) {
      //         //     if ((i == v.length-1) && !(v => /.+@.+/.test(v)))
      //         //       return 'Invalid email';
      //         //     }
      //         //   }
      //         //   else return true;
      //         }
      //       ]
    }
  },
  mounted ()  {
    this.makeid()
    console.log(window.innerHeight)
    // let height = this.$refs.infoBox.clientHeight;
    // console.log(height)
  },
  watch:{
    member () {
      const list_member = this.member
      this.member_invite = list_member
      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = list_member.filter(email =>
        !regex.test(email)
      )
      // console.log(result)
      if(result.length == 0){
        // mail ok
        this.checktypemail = true
      }else{
        this.checktypemail = false
      }
    }
  },
  methods: {
    cancle() {
      this.$swal({
        title: 'ต้องการลบข้อมูลทั้งหมดใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1976d2',
        cancelButtonColor: 'grey',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.subject = ''
          this.date = null
          this.time = null
          this.duration = ''
          this.member = []
          this.makeid()
        }
      })

    },
    disableBtn () {
      if( this.subject != '' && this.date != null && this.time != null &&this.duration != '' && this.password != '' && this.member_invite.length>0 &&this.checktypemail == true){
        return false
      }else {
        return true
      }
    },
    openDialog () {
      this.createroom_dialog = true
    },
    closeDialog (value) {
      this.createroom_dialog = value
    },
    updateTags() {
      this.member.push(...this.search.split(","));
      this.search = "";

    },
    makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 7; i++){
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
        // console.log(text)
        this.password = text
      },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    createRoomConference () {
      var data = {
        subject:this.subject,
        key:this.password,
        date:this.date,
        time:this.time,
        duration: this.duration,
        secretroom: this.switch1,
        member: this.member_invite
      }
      console.log(data)
    }
  }
}
</script>

<style scoped>
.bodyConference{
  padding: 40px 80px;
}

.bodytab{
  padding-left: 80px;
  padding-right: 80px;
}

.profile{
  width: 300px;
  height: 100px;
}

>>>.v-input__slot {
  width: 100% !important;
  box-sizing: border-box !important;
  background-color: rgb(255, 255, 255) !important;
  /* border: 1px solid rgb(210, 216, 221) !important; */
  border-radius: 4px !important;
}

>>>.v-messages__message {
    display: flex;
}

.edit {
  font-weight: 100;
}
.inputWrapper {
    height: 32px;
    width: 90px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
}


input[type=textprofile] {
    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
input[type=textprofile]:disabled {
    background: #cac9c9;
}




.EditAreaNote {
    margin: 8px 0 0;
    font-size: 13px;
    color: #BEC8D2;
    font-size: 12px;
}
.EditArea {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}
.EditAreaCont {
    width: 100%;
    padding-right: 1em;
    box-sizing: border-box;
}



.InputEdit {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}

.headerInput{
  color: gray;
  font-size: 16px;
  margin-left: 30px;
  font-weight: bold;
}

.headerInputMobile{
  color: gray;
  font-size: 14px;
  font-weight: bold;
}

.Inputminute{
  color: gray;
}

.mx-datepicker {
    position: relative;
    display: unset;
    width: 210px;
}

>>>.mx-input {
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 43px;
    padding: 6px 30px;
    padding-left: 10px;
    font-size: 14px;
    line-height: 1.4;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}
>>>.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
    padding-top: 0px;
}
/* .v-combobox{
  max-height: 20px;
} */
>>>.v-text-field--outline.v-input--is-focused .v-input__slot {
    border: 2px solid;
    transition: border .3s cubic-bezier(.25,.8,.5,1);
    min-height: -webkit-fill-available;
}
>>>.v-text-field.v-input__slot, .v-text-field--outline .v-input__slot{
  min-height:36px;
}
>>>.v-input--selection-controls .v-input__slot {
    margin-bottom: 0px !important;
}

/* >>>.v-input__slot {
  resize: none;
  min-height: 44px;
  max-height: 100px;
  overflow-y: auto;
} */

>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 43px;
    padding: 6px 30px;
    padding-left: 10px;
    font-size: 14px;
    line-height: 1.4;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

>>>.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 4px;
}

.web{
  height: calc(100vh -300px);
  overflow-y: auto;
}

.other_web{
  height: 200px;
  overflow-y: auto;
}

.web::-webkit-scrollbar {
  width: 6px;
}

/* Track */
.web::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.web::-webkit-scrollbar-thumb {
  background: #E0E0E0;
  border-radius:4px;
}


.other_web::-webkit-scrollbar {
  width: 10px;
}

/* Track */
/* .other_web::-webkit-scrollbar-track {
  background: #f1f1f1;
} */

.other_web::-webkit-scrollbar-thumb {
  background: #E0E0E0;
  border-radius:4px;
}

.other_web::-webkit-scrollbar {
  width: 4px;
}

/* .mobilelayoutX{
  height:calc(55vh - 150px);
  overflow-y:auto;
  overflow-x: hidden;
} */
.mobilelayout::-webkit-scrollbar-thumb{
  background: #E0E0E0;
  border-radius:4px;
}

.mobilelayout::-webkit-scrollbar {
  width: 4px;
}

.mobilelayout{
  height:calc(100vh - 150px);
  overflow-y:auto;
  overflow-x: hidden;
}
.mobilelayout::-webkit-scrollbar-thumb{
  background: #E0E0E0;
  border-radius:4px;
}

.mobilelayout::-webkit-scrollbar {
  width: 4px;
}
.v-tabs__item {
  color: #1976D2 !important;
}
/* >>>.tag-input .v-input--is-focused .v-input__slot {
  border: 2px solid red !important;
}

>>>.tag-input .v-text-field--outline.v-input--is-focused .v-input__slot {
    border: 2px solid red !important;
} */

</style>


// WEBPACK FOOTER //
// src/components/conference/layoutConference.vue